import type { KpopFestivalState } from './type'

export const initKpopFestivalState: KpopFestivalState = {
  kpopFestivalTerms: [],
  kpopFestivalApplyStatus: null,
}
